import React, { Component, Fragment } from 'react';
import { NavLink } from 'reactstrap';

const Logout = props => {
    const logout = () => {
        localStorage.clear()
        props.setAuthenticated(false)
    }
    return (
        <Fragment>
            <NavLink onClick={logout} href = "#">
                Logout
            </NavLink>
        </Fragment>
    );
}

export default Logout